export enum UserLevelValue {
  DITEC = 'DITEC',
  TECOM = 'TECOM',
  DIVEN = 'DIVEN',
  PARTNER = 'PARTNER',
}

const USER_LEVEL_ROLE_PREFIX = 'product-selection-tools:robuschi|';

export class UserLevel {
  private static readonly ALL: UserLevel[] = [];

  public static readonly DITEC = new UserLevel(UserLevelValue.DITEC, 'DiTec', 30);
  public static readonly TECOM = new UserLevel(UserLevelValue.TECOM, 'TeCom', 25);
  public static readonly DIVEN = new UserLevel(UserLevelValue.DIVEN, 'DiVen', 20);
  public static readonly PARTNER = new UserLevel(UserLevelValue.PARTNER, 'Partner', 10);

  public static resolveFor(value: string | null | undefined): UserLevel | undefined {
    return UserLevel.ALL.find((level) => level.value === value?.toUpperCase());
  }

  public static labelFor(value: string | null | undefined): string {
    return UserLevel.resolveFor(value)?.label ?? '—';
  }

  public static rankFor(value: string | null | undefined): number {
    return UserLevel.resolveFor(value)?.rank ?? 0;
  }

  public static resolveForRoles(roles: string[]): UserLevel | undefined {
    const normalizedRoles = new Set(roles.map((role) => role.trim().toLowerCase()));
    return UserLevel.ALL.find((level) => normalizedRoles.has(level.roleName.toLowerCase()));
  }

  public static getOffered(): UserLevel[] {
    return [...UserLevel.ALL];
  }

  private constructor(
    public readonly value: UserLevelValue,
    public readonly name: string,
    public readonly rank: number,
  ) {
    UserLevel.ALL.push(this);
  }

  public get roleName(): string {
    return `${USER_LEVEL_ROLE_PREFIX}${this.name}`;
  }

  public get label(): string {
    return this.name;
  }

  public get canAccessAdmin(): boolean {
    return this === UserLevel.DITEC;
  }

  public get visibilityHintKey(): string {
    return `ADMIN.COMMON.VISIBILITY_HINT_${this.value}`;
  }
}
